exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__Spinner__spinnerContainer__k5M_V {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 5px;\n  z-index: 10000;\n}\n\n.dmb-web__Spinner__spinner__3sqAP {\n  height: 5px;\n  background: #F7A700;\n  -webkit-animation: dmb-web__Spinner__pulse__2dZm7 3s ease-in-out 0s infinite;\n          animation: dmb-web__Spinner__pulse__2dZm7 3s ease-in-out 0s infinite;\n  margin: 0 auto;\n}\n\n@-webkit-keyframes dmb-web__Spinner__pulse__2dZm7 {\n  0% {\n    width: 10%;\n  }\n\n  50% {\n    width: 95%;\n  }\n\n  100% {\n    width: 10%;\n  }\n}\n\n@keyframes dmb-web__Spinner__pulse__2dZm7 {\n  0% {\n    width: 10%;\n  }\n\n  50% {\n    width: 95%;\n  }\n\n  100% {\n    width: 10%;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"spinnerContainer": "dmb-web__Spinner__spinnerContainer__k5M_V",
	"spinner": "dmb-web__Spinner__spinner__3sqAP",
	"pulse": "dmb-web__Spinner__pulse__2dZm7"
};